import { useEffect } from "react";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Packages from "@/components/sections/Packages";
import Services from "@/components/sections/Services";
import Upcoming from "@/components/sections/Upcoming";
import WhyUs from "@/components/sections/WhyUs";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import FloatingWhatsapp from "@/components/FloatingWhatsapp";

export default function Home() {
  useEffect(() => {
    document.title =
      "DreamFly Travels · Luxury travel, naturally — Maldives, Europe, UK, Thailand, Africa";
    const meta = document.querySelector('meta[name="description"]');
    const desc =
      "DreamFly Travels designs curated international and domestic holidays — Maldives water villas, Europe grand tours, UK escapes, Thailand, Africa safaris. Luxury travel at sensible prices.";
    if (meta) meta.setAttribute("content", desc);
    else {
      const m = document.createElement("meta");
      m.name = "description";
      m.content = desc;
      document.head.appendChild(m);
    }
  }, []);

  return (
    <main data-testid="home-page" className="bg-[#FAFAFA]">
      <Navbar />
      <Hero />
      <About />
      <Packages />
      <Services />
      <Upcoming />
      <WhyUs />
      <Contact />
      <Footer />
      <FloatingWhatsapp />
    </main>
  );
}
